export default __webpack_public_path__ + "f28424adda3d941cd1c650d3c7a4bc83.png";